module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.8a12c702.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-SemiBold.woff
// module id = 703
// module chunks = 21